/**
 * Interfaz para representar a un perfil
 */
export interface Profile {
  id: number;
  name: string;
  profile_module_permissions?: ModulePermission[];
}

export interface ModulePermission {
  module_id: number;
  module: string;
  title: string;
  permissions: Permission[];
}

export interface Permission {
  name: 'CREATE' | 'READ' | 'UPDATE' | 'DELETE';
  allow: boolean;
  permission_id: PermissionId;
}

export enum PermissionId {
  Read = 1,
  Create = 2,
  Update = 3,
  Delete = 4,
}
